import type { ExtensionAttribute } from '@tiptap/react';

export function getSplittedAttributes(
  extensionAttributes: ExtensionAttribute[],
  typeName: string,
  attributes: Record<string, any>
): Record<string, any> {
  return Object.entries(attributes).reduce<Record<string, any>>((result, [name, value]) => {
    const extensionAttribute = extensionAttributes.find(item => {
      return item.type === typeName && item.name === name;
    });

    if (extensionAttribute && extensionAttribute.attribute.keepOnSplit) {
      result[name] = value;
    }

    return result;
  }, {});
}
